// Agoda API Integration Service
// Note: This is a mock implementation for development purposes
// In production, you would need to integrate with actual Agoda API

export const agodaApiConfig = {
  // API Configuration
  baseUrl: 'https://api.agoda.com/v1', // Mock URL
  apiKey: process.env.REACT_APP_AGODA_API_KEY || 'mock-api-key',
  timeout: 30000, // 30 seconds
  
  // Default Parameters
  defaultParams: {
    language: 'th',
    currency: 'THB',
    country: 'TH',
    limit: 20,
    offset: 0
  },
  
  // Rate Limiting
  rateLimit: {
    requestsPerMinute: 60,
    requestsPerHour: 1000
  }
};

// Property Types Mapping
export const propertyTypeMapping = {
  hotels: {
    agodaTypes: ['hotel', 'resort', 'boutique', 'luxury', 'business'],
    searchKeywords: ['hotel', 'resort', 'accommodation']
  },
  restaurants: {
    agodaTypes: ['restaurant', 'cafe', 'fine_dining', 'street_food', 'bar'],
    searchKeywords: ['restaurant', 'cafe', 'dining', 'food']
  },
  attractions: {
    agodaTypes: ['attraction', 'museum', 'park', 'temple', 'landmark'],
    searchKeywords: ['attraction', 'tourist', 'sightseeing', 'activity']
  }
};

// Mock Data for Development
const mockProperties = {
  hotels: [
    {
      id: 'hotel_001',
      name: 'Grand Palace Hotel',
      nameEn: 'Grand Palace Hotel',
      type: 'hotel',
      category: 'luxury',
      rating: 4.5,
      reviewCount: 1234,
      price: {
        amount: 2500,
        currency: 'THB',
        period: 'night'
      },
      location: {
        address: '123 Silom Road, Bangkok',
        district: 'Silom',
        city: 'Bangkok',
        coordinates: {
          latitude: 13.7246,
          longitude: 100.5340
        }
      },
      amenities: ['WiFi', 'Pool', 'Gym', 'Spa', 'Restaurant'],
      images: [
        'https://via.placeholder.com/400x300/4F46E5/FFFFFF?text=Grand+Palace+Hotel',
        'https://via.placeholder.com/400x300/7C3AED/FFFFFF?text=Luxury+Room',
        'https://via.placeholder.com/400x300/059669/FFFFFF?text=Hotel+Pool'
      ],
      description: 'Luxury hotel in the heart of Bangkok with modern amenities and excellent service.',
      descriptionEn: 'Luxury hotel in the heart of Bangkok with modern amenities and excellent service.',
      availability: {
        available: true,
        checkIn: '2024-01-15',
        checkOut: '2024-01-16',
        roomsAvailable: 5
      },
      agodaUrl: 'https://www.agoda.com/grand-palace-hotel',
      commissionRate: 0.08, // 8% commission
      isActive: true
    },
    {
      id: 'hotel_002',
      name: 'Riverside Resort',
      nameEn: 'Riverside Resort',
      type: 'resort',
      category: 'boutique',
      rating: 4.2,
      reviewCount: 856,
      price: {
        amount: 1800,
        currency: 'THB',
        period: 'night'
      },
      location: {
        address: '456 Chao Phraya Road, Bangkok',
        district: 'Riverside',
        city: 'Bangkok',
        coordinates: {
          latitude: 13.7297,
          longitude: 100.5119
        }
      },
      amenities: ['WiFi', 'Pool', 'Restaurant', 'River View'],
      images: [
        'https://via.placeholder.com/400x300/DC2626/FFFFFF?text=Riverside+Resort',
        'https://via.placeholder.com/400x300/EA580C/FFFFFF?text=River+View',
        'https://via.placeholder.com/400x300/16A34A/FFFFFF?text=Resort+Garden'
      ],
      description: 'Boutique resort with stunning river views and peaceful atmosphere.',
      descriptionEn: 'Boutique resort with stunning river views and peaceful atmosphere.',
      availability: {
        available: true,
        checkIn: '2024-01-15',
        checkOut: '2024-01-16',
        roomsAvailable: 3
      },
      agodaUrl: 'https://www.agoda.com/riverside-resort',
      commissionRate: 0.07,
      isActive: true
    }
  ],
  restaurants: [
    {
      id: 'restaurant_001',
      name: 'Siam Kitchen',
      nameEn: 'Siam Kitchen',
      type: 'restaurant',
      category: 'fine_dining',
      rating: 4.7,
      reviewCount: 2341,
      price: {
        amount: 800,
        currency: 'THB',
        period: 'person'
      },
      location: {
        address: '789 Sukhumvit Road, Bangkok',
        district: 'Sukhumvit',
        city: 'Bangkok',
        coordinates: {
          latitude: 13.7388,
          longitude: 100.5603
        }
      },
      amenities: ['WiFi', 'Air Conditioning', 'Parking', 'Takeaway'],
      images: [
        'https://via.placeholder.com/400x300/EF4444/FFFFFF?text=Siam+Kitchen',
        'https://via.placeholder.com/400x300/F97316/FFFFFF?text=Fine+Dining',
        'https://via.placeholder.com/400x300/84CC16/FFFFFF?text=Thai+Cuisine'
      ],
      description: 'Authentic Thai fine dining restaurant with traditional recipes and modern presentation.',
      descriptionEn: 'Authentic Thai fine dining restaurant with traditional recipes and modern presentation.',
      availability: {
        available: true,
        openHours: '11:00-22:00',
        reservationsRequired: true,
        tablesAvailable: 2
      },
      agodaUrl: 'https://www.agoda.com/siam-kitchen',
      commissionRate: 0.05,
      isActive: true
    },
    {
      id: 'restaurant_002',
      name: 'Street Food Corner',
      nameEn: 'Street Food Corner',
      type: 'restaurant',
      category: 'street_food',
      rating: 4.3,
      reviewCount: 1567,
      price: {
        amount: 150,
        currency: 'THB',
        period: 'person'
      },
      location: {
        address: '321 Yaowarat Road, Bangkok',
        district: 'Chinatown',
        city: 'Bangkok',
        coordinates: {
          latitude: 13.7400,
          longitude: 100.5100
        }
      },
      amenities: ['Outdoor Seating', 'Cash Only'],
      images: [
        'https://via.placeholder.com/400x300/8B5CF6/FFFFFF?text=Street+Food',
        'https://via.placeholder.com/400x300/EC4899/FFFFFF?text=Local+Cuisine',
        'https://via.placeholder.com/400x300/06B6D4/FFFFFF?text=Chinatown'
      ],
      description: 'Authentic street food experience in the heart of Chinatown.',
      descriptionEn: 'Authentic street food experience in the heart of Chinatown.',
      availability: {
        available: true,
        openHours: '18:00-02:00',
        reservationsRequired: false,
        tablesAvailable: 8
      },
      agodaUrl: 'https://www.agoda.com/street-food-corner',
      commissionRate: 0.03,
      isActive: true
    }
  ],
  attractions: [
    {
      id: 'attraction_001',
      name: 'Grand Palace',
      nameEn: 'Grand Palace',
      type: 'attraction',
      category: 'landmark',
      rating: 4.8,
      reviewCount: 4567,
      price: {
        amount: 500,
        currency: 'THB',
        period: 'person'
      },
      location: {
        address: 'Na Phra Lan Road, Bangkok',
        district: 'Phra Nakhon',
        city: 'Bangkok',
        coordinates: {
          latitude: 13.7500,
          longitude: 100.4915
        }
      },
      amenities: ['Audio Guide', 'Guided Tours', 'Gift Shop'],
      images: [
        'https://via.placeholder.com/400x300/F59E0B/FFFFFF?text=Grand+Palace',
        'https://via.placeholder.com/400x300/10B981/FFFFFF?text=Temple+Wat+Phra+Kaew',
        'https://via.placeholder.com/400x300/3B82F6/FFFFFF?text=Royal+Architecture'
      ],
      description: 'Historic royal palace complex and temple of the Emerald Buddha.',
      descriptionEn: 'Historic royal palace complex and temple of the Emerald Buddha.',
      availability: {
        available: true,
        openHours: '08:30-15:30',
        advanceBooking: true,
        dailyCapacity: 1000
      },
      agodaUrl: 'https://www.agoda.com/grand-palace',
      commissionRate: 0.04,
      isActive: true
    }
  ]
};

// API Service Class
class AgodaApiService {
  constructor() {
    this.baseUrl = agodaApiConfig.baseUrl;
    this.apiKey = agodaApiConfig.apiKey;
    this.timeout = agodaApiConfig.timeout;
    this.requestQueue = [];
    this.lastRequestTime = 0;
  }

  // Rate limiting helper
  async rateLimitDelay() {
    const now = Date.now();
    const timeSinceLastRequest = now - this.lastRequestTime;
    const minInterval = 60000 / agodaApiConfig.rateLimit.requestsPerMinute; // 1 second between requests
    
    if (timeSinceLastRequest < minInterval) {
      await new Promise(resolve => setTimeout(resolve, minInterval - timeSinceLastRequest));
    }
    
    this.lastRequestTime = Date.now();
  }

  // Make API request with error handling
  async makeRequest(endpoint, params = {}) {
    try {
      await this.rateLimitDelay();
      
      const url = new URL(`${this.baseUrl}${endpoint}`);
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });
      
      // Add API key
      url.searchParams.append('apiKey', this.apiKey);
      
      console.log('🌐 Making Agoda API request:', url.toString());
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), this.timeout);
      
      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('✅ Agoda API response received');
      
      return {
        success: true,
        data: data
      };
      
    } catch (error) {
      console.error('❌ Agoda API request failed:', error);
      
      // Return mock data for development
      if (process.env.NODE_ENV === 'development') {
        console.log('🔄 Returning mock data for development');
        return this.getMockData(endpoint, params);
      }
      
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Get mock data for development
  getMockData(endpoint, params) {
    const { cityId, propertyType, limit = 20, offset = 0 } = params;
    
    let mockData = [];
    
    if (endpoint.includes('/hotels')) {
      mockData = mockProperties.hotels;
    } else if (endpoint.includes('/restaurants')) {
      mockData = mockProperties.restaurants;
    } else if (endpoint.includes('/attractions')) {
      mockData = mockProperties.attractions;
    } else {
      // Combined search
      mockData = [
        ...mockProperties.hotels,
        ...mockProperties.restaurants,
        ...mockProperties.attractions
      ];
    }
    
    // Apply pagination
    const paginatedData = mockData.slice(offset, offset + limit);
    
    return {
      success: true,
      data: {
        properties: paginatedData,
        total: mockData.length,
        limit,
        offset,
        hasMore: offset + limit < mockData.length
      }
    };
  }

  // Search properties by city
  async searchProperties(cityId, options = {}) {
    const {
      propertyType = 'all',
      limit = 20,
      offset = 0,
      minPrice,
      maxPrice,
      rating,
      amenities = [],
      sortBy = 'rating',
      sortOrder = 'desc'
    } = options;
    
    const params = {
      cityId,
      limit,
      offset,
      sortBy,
      sortOrder,
      ...agodaApiConfig.defaultParams
    };
    
    if (minPrice !== undefined) params.minPrice = minPrice;
    if (maxPrice !== undefined) params.maxPrice = maxPrice;
    if (rating !== undefined) params.rating = rating;
    if (amenities.length > 0) params.amenities = amenities.join(',');
    
    let endpoint = '/search';
    if (propertyType !== 'all') {
      endpoint = `/${propertyType}/search`;
    }
    
    return await this.makeRequest(endpoint, params);
  }

  // Get property details
  async getPropertyDetails(propertyId) {
    return await this.makeRequest(`/properties/${propertyId}`);
  }

  // Check availability
  async checkAvailability(propertyId, checkIn, checkOut, guests = 1) {
    const params = {
      checkIn,
      checkOut,
      guests,
      ...agodaApiConfig.defaultParams
    };
    
    return await this.makeRequest(`/properties/${propertyId}/availability`, params);
  }

  // Get property reviews
  async getPropertyReviews(propertyId, limit = 10, offset = 0) {
    const params = {
      limit,
      offset,
      ...agodaApiConfig.defaultParams
    };
    
    return await this.makeRequest(`/properties/${propertyId}/reviews`, params);
  }

  // Get nearby properties
  async getNearbyProperties(latitude, longitude, radius = 5, propertyType = 'all') {
    const params = {
      latitude,
      longitude,
      radius,
      ...agodaApiConfig.defaultParams
    };
    
    let endpoint = '/nearby';
    if (propertyType !== 'all') {
      endpoint = `/${propertyType}/nearby`;
    }
    
    return await this.makeRequest(endpoint, params);
  }

  // Get property images
  async getPropertyImages(propertyId) {
    return await this.makeRequest(`/properties/${propertyId}/images`);
  }

  // Create booking request
  async createBookingRequest(bookingData) {
    const {
      propertyId,
      checkIn,
      checkOut,
      guests,
      rooms = 1,
      guestInfo,
      paymentInfo
    } = bookingData;
    
    const params = {
      propertyId,
      checkIn,
      checkOut,
      guests,
      rooms,
      guestInfo: JSON.stringify(guestInfo),
      paymentInfo: JSON.stringify(paymentInfo),
      ...agodaApiConfig.defaultParams
    };
    
    return await this.makeRequest('/bookings', params);
  }

  // Get booking status
  async getBookingStatus(bookingId) {
    return await this.makeRequest(`/bookings/${bookingId}`);
  }

  // Cancel booking
  async cancelBooking(bookingId, reason = '') {
    const params = {
      reason,
      ...agodaApiConfig.defaultParams
    };
    
    return await this.makeRequest(`/bookings/${bookingId}/cancel`, params);
  }
}

// Create singleton instance
export const agodaApiService = new AgodaApiService();

// Helper functions
export const formatPropertyForDisplay = (property) => {
  return {
    ...property,
    formattedPrice: `${property.price.currency} ${property.price.amount.toLocaleString()}`,
    pricePerPeriod: `${property.price.amount.toLocaleString()} ${property.price.currency}/${property.price.period}`,
    ratingStars: '★'.repeat(Math.floor(property.rating)) + '☆'.repeat(5 - Math.floor(property.rating)),
    formattedLocation: `${property.location.district}, ${property.location.city}`,
    primaryImage: property.images?.[0] || 'https://via.placeholder.com/400x300/6B7280/FFFFFF?text=No+Image',
    isAvailable: property.availability?.available || false,
    commissionAmount: property.price.amount * (property.commissionRate || 0)
  };
};

export const filterPropertiesByType = (properties, propertyType) => {
  if (propertyType === 'all') return properties;
  
  const typeMapping = propertyTypeMapping[propertyType];
  if (!typeMapping) return properties;
  
  return properties.filter(property => 
    typeMapping.agodaTypes.includes(property.type) ||
    typeMapping.agodaTypes.includes(property.category)
  );
};

export const sortProperties = (properties, sortBy, sortOrder = 'desc') => {
  return [...properties].sort((a, b) => {
    let aValue, bValue;
    
    switch (sortBy) {
      case 'price':
        aValue = a.price.amount;
        bValue = b.price.amount;
        break;
      case 'rating':
        aValue = a.rating;
        bValue = b.rating;
        break;
      case 'reviewCount':
        aValue = a.reviewCount;
        bValue = b.reviewCount;
        break;
      case 'name':
        aValue = a.name.toLowerCase();
        bValue = b.name.toLowerCase();
        break;
      default:
        aValue = a.rating;
        bValue = b.rating;
    }
    
    if (sortOrder === 'asc') {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });
};

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth's radius in kilometers
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

export const getNearbyProperties = (properties, userLat, userLon, radiusKm = 5) => {
  return properties.filter(property => {
    const distance = calculateDistance(
      userLat, userLon,
      property.location.coordinates.latitude,
      property.location.coordinates.longitude
    );
    return distance <= radiusKm;
  }).map(property => ({
    ...property,
    distance: calculateDistance(
      userLat, userLon,
      property.location.coordinates.latitude,
      property.location.coordinates.longitude
    )
  })).sort((a, b) => a.distance - b.distance);
};

